import { InjectionToken } from '@angular/core';
export interface SpritesPaths {
  PRODUCT: string;
  FILTER: string;
  LIST_TAGS: string;
}
export const SPRITES_PATHS_TOKEN: InjectionToken<SpritesPaths> =
  new InjectionToken('Sprites Paths');
